import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
Swiper.use([ A11y, Navigation]);

jQuery(document).ready(function() {
  if (jQuery('.swiper-services').length) {
    new Swiper('.swiper-services', {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 1000,
      a11y: {
        enabled: true,
      },
      navigation: {
        nextEl: '.swiper-services-navigation .swiper-button-next',
        prevEl: '.swiper-services-navigation .swiper-button-prev',
      },
      breakpoints: {
        991: {
          slidesPerView: 3,
        },
        575: {
          slidesPerView: 2,
        },
      },
    });
  }
});
